import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import carFill from '@iconify/icons-eva/car-fill';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import listFill from '@iconify/icons-eva/list-fill';
import personAddFill from '@iconify/icons-eva/person-add-fill';
import settingsFill from '@iconify/icons-eva/settings-fill';
import bellFill from '@iconify/icons-eva/bell-fill';
import briefcase from '@iconify/icons-eva/briefcase-fill';
import file from '@iconify/icons-eva/file-outline';



// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} sx={{color:"#c29136"}} />;

const sidebarConfig = [
  {
    title: 'Car Details',
    path: '/dashboard/app',
    icon: getIcon('ion:car')
  },
  {
    title: 'Proforma Invoices',
    path: '/dashboard/proforma/invoices',
    icon: getIcon(file)
  },
  {
    title: 'Final Invoices',
    path: '/dashboard/final/invoices',
    icon: getIcon(file)
  },
  {
    title: 'Agreements',
    path: '/dashboard/agreements',
    icon: getIcon(file)
  },
  {
    title: 'Accounts',
    path: '/dashboard/accounts',
    icon: getIcon(briefcase)
  },
  {
    title: 'Installment Plan',
    path: '/dashboard/installments',
    icon: getIcon(file)
  },
  {
    title: 'Re Processing Plan',
    path: '/dashboard/reprocessings',
    icon: getIcon(file)
  },
  {
    title: 'Cheque Management',
    path: '#',
    icon: getIcon(file)
  },
  {
    title: 'Log Books',
    path: '#',
    icon: getIcon(file)
  },
  {
    title: 'settings',
    path: '#',
    icon: getIcon(settingsFill)
  }
];

export default sidebarConfig;
